import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes';
//import App from './App'

import './assets/site.css'; // Tell webpack that Button.js uses these styles
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File

import './i18n';


ReactDOM.render(<Routes />, document.getElementById('root'));
